import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
} from '@material-ui/core';
import { ActionConfirmationDisplay } from './types';
import {
  AWSActionType,
  GCPActionType,
  KubernetesActionType,
  AzureActionType,
  ProjectCodeActionType,
} from '@internal/backstage-plugin-compute-resource-discovery-new-common';

type AllActionTypes =
  | AWSActionType
  | GCPActionType
  | KubernetesActionType
  | AzureActionType
  | ProjectCodeActionType;

interface ConfirmationDialogProps<T extends AllActionTypes = AllActionTypes> {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  action?: T;
  title: string;
  content: string;
  isLoading: boolean;
  actionDisplay: ActionConfirmationDisplay;
}

export function ActionConfirmationDialog<
  T extends AllActionTypes = AllActionTypes,
>({
  open,
  onClose,
  onConfirm,
  isLoading,
  actionDisplay,
  title,
  content,
}: ConfirmationDialogProps<T>) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{content}</DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color={actionDisplay.color}
          variant="contained"
          disabled={isLoading}
          startIcon={isLoading ? <CircularProgress size={20} /> : null}
        >
          {isLoading ? `${actionDisplay.text}ing...` : actionDisplay.text}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
